import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { StatisticsMetrics } from './StatisticsMetrics.js';
import actions from './StatisticsMetrics.actions';
import {
    mainSelector,
    getCheckedKeys,
    getMetrics
} from './StatisticsMetrics.selectors';

const mapStateToPropsSelectors = createStructuredSelector({
    data: mainSelector,
    checkedKeys: getCheckedKeys,
    metrics: getMetrics
});

const StatisticsMetricsComponent = connect(
    function mapStateToProps(state) {
        return {
            ...mapStateToPropsSelectors(state),
            location: state.routing.locationBeforeTransitions
        };
    },
    function mapDispatchToProps(dispatch) {
        return {
            saveServerStorage: actions.saveServerStorage
        };
    }
)(StatisticsMetrics);

export default StatisticsMetricsComponent;
